// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7cDJx","right":"styles_right__NEkvT"};